import { Box, Button, FlexBox } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import { aiApi } from 'apis/ai';
import { appActions } from 'app/app.actions';
import { TranslationBadgeDropdownContentProps } from 'components/translationBadge/translationBadge.types';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

/**
 * Represents the component for displaying the translate badge dropdown content
 * in case of error.
 */
export const ErrorDropdownContent = (
  props: TranslationBadgeDropdownContentProps,
): JSX.Element => {
  const { feedbackId, onAdditionalFeedback } = props;
  const dispatch = useAppDispatch();

  const handleFeedbackButtonClick = useCallback(async () => {
    onAdditionalFeedback?.();

    const { isSent, feedbackMessage } = await dispatch(
      appActions.showModal({
        modal: {
          type: 'app:feedbackForm',
          arg: {
            title: 'Translation feedback',
            team: 'conversations',
            placeholder:
              'Provide any insights that can help us to address the issue.',
            extra: {
              feedback: 'bad',
              feedbackId,
            },
          },
        },
      }),
    );

    if (isSent && feedbackMessage) {
      dispatch(
        aiApi.endpoints.createAiFeedback.initiate({
          feedbackId,
          feedback: [
            {
              type: 'rating',
              value: 'bad',
            },
            {
              type: 'comment',
              value: feedbackMessage,
            },
          ],
        }),
      );
    }
  }, [dispatch, feedbackId, onAdditionalFeedback]);

  return (
    <FlexBox flexDirection="column" gap="300" padding="300">
      <Box>We are sorry that this happened.</Box>

      <FlexBox gap="200" justifyContent="center">
        <Button variant="secondary" onClick={handleFeedbackButtonClick}>
          Send us feedback
        </Button>
      </FlexBox>
    </FlexBox>
  );
};
